import apiConfig from "config/api";
import { ROUTES } from "config";

const padFacadeURL = (url) => `${apiConfig.baseUrl}/${url}`;
const getPhotoUrl = (photo) => {
    if (!photo) return null;
    return padFacadeURL(`${ROUTES.PHOTO_CONTAINER}/${photo}`);
};

export { padFacadeURL, getPhotoUrl };
